import Cards from "../../components/Cards";
import * as S from "./styled";
import Header from "../../components/Header";
import CardsSelect from "../../components/CardsSelect";
import ButtonDefault from "../../components/ButtonDefault";
import CardsSelects from "../../components/CardsSelects";
import { useQuizController } from "../../controller/quizController";
import { Input } from "../../components/Input";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import arrowLeft from '../../assets/Lottie/arrowLeft.json';

import Home1 from "../../assets/Img/H/h1.webp";
import Home2 from "../../assets/Img/H/h2.webp";
import Home3 from "../../assets/Img/H/h3.webp";
import Home4 from "../../assets/Img/H/h4.webp";

import Mulher1 from "../../assets/Img/M/m1.webp";
import Mulher2 from "../../assets/Img/M/m2.webp";
import Mulher3 from "../../assets/Img/M/m3.webp";
import Mulher4 from "../../assets/Img/M/m4.webp";

import Close from "../../assets/Img/close.jpg";
import Weight from "../../assets/Img/weight.jpg";
import { Chart } from 'primereact/chart';
import { Loading } from "../../components/Loading";

import loafing from '../../assets/Lottie/loading.json';
import theme from "../../theme";
import ReactPixel from 'react-facebook-pixel';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Woman2 from "../../assets/Img/M/woman2.png";
import Man2 from "../../assets/Img/H/man2.png";
import Lottie from "lottie-react-web";

export default function Quiz() {
    const { t } = useTranslation();
    const {
        loading,
        handleFunctions,
        setName,
        name,
        setEmail,
        email,
        data,
        status,
        progress,
        currentStep,
        selectedBodyType,
        setSelectedBodyType,
        bodyGoal,
        setBodyGoal,
        setAge,
        setGoal,
        motivation,
        setMotivation,
        selectedGoals,
        target,
        setTarget,
        lastWeight,
        setLastWeight,
        conditioning,
        setConditioning,
        pushUps,
        setPushUps,
        lifestyle,
        setLifestyle,
        youWalk,
        setYouWalk,
        meals,
        setMeals,
        sleeps,
        setSleeps,
        water,
        setWater,
        training,
        setTraining,
        occasion,
        setOccasion,
        height,
        setHeight,
        weight,
        setWeight,
        weightGoal,
        setWeightGoal,
        imc,
        totalSteps,
        getIMCMessage,
        handleNextStep,
        handleContinue,
        toggleGoalSelection,
        gender,
        getIMCImage
    } = useQuizController();

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        if (weight !== undefined && weightGoal !== undefined && imc !== undefined) {
            const weightNumber = parseFloat(weight);
            const weightGoalNumber = parseFloat(weightGoal);
            const imcNumber = parseFloat(imc);
            const differentiate = weightGoalNumber - weightNumber;

            const data = {
                labels: [
                    '2024',
                    '2025'
                ],
                datasets: [
                    {
                        data: [weightNumber, weightGoalNumber],
                        label: `${t('labels_goal')}`,
                        backgroundColor: [
                            'rgba(38, 194, 255, 0.2)',
                            theme.COLORS.SUCCESS,
                        ],
                        hoverBackgroundColor: [
                            theme.COLORS.PRIMARY,
                            theme.COLORS.SUCCESS,
                        ],
                        tension: 0.4,
                        fill: true,
                        borderColor: theme.COLORS.PRIMARY,
                    },
                ]
            };

            const options = {
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: theme.COLORS.TITLE,
                        }
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            color: theme.COLORS.DESCRIPTION,
                        },
                        grid: {
                            color: theme.COLORS.DESCRIPTION,
                        }
                    },
                    y: {
                        ticks: {
                            color: theme.COLORS.DESCRIPTION,
                        },
                        grid: {
                            color: theme.COLORS.DESCRIPTION,
                        }
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem: any) {
                            const label = tooltipItem.label;
                            const value = tooltipItem.raw;
                            return `${label}: ${value}`;
                        }
                    }
                },
            };

            setChartData(data);
            setChartOptions(options);
        }
    }, [weight, weightGoal, imc]);

    const getMotivationMessage = () => {
        if (!motivation) return null;

        switch (motivation) {
            case 'health':
                return t('motivation_health');
            case 'fitness':
                return t('motivation_fitness');
            case 'performance':
                return t('motivation_performance');
            default:
                return t('motivation_default');
        }
    };

    useEffect(() => {
        // Não é necessário inicializar o Pixel novamente aqui se já fez no App
        ReactPixel.track('quiz', { action: 'passos do quiz' });
    }, []);

    if (loading) {
        return (
            <Loading
                animationData={loafing}
                height={100}
                width={100}
                bg={theme.COLORS.BACKGROUND}
                title={t('title_loading')}
            />
        )
    };

    return (
        <S.Container>
            <Header>
                <S.ContainerHeader>
                    <S.ProgressSteps>
                        {t('quiz_progress_steps', { currentStep, totalSteps })}
                    </S.ProgressSteps>
                    <S.ProgressBar>
                        <S.Progress style={{ width: `${progress}%` }} />
                    </S.ProgressBar>
                </S.ContainerHeader>
            </Header>

            {currentStep === 1 && (
                <>
                    <S.Title>
                        {t('quiz_title_age')}
                    </S.Title>

                    <S.Content>
                        <Cards
                            title={t('quiz_age_group_18_29')}
                            img={gender === 'homem' ? Home1 : Mulher1}
                            onClick={() => handleNextStep(() => setAge("18-29"))}
                        />
                        <Cards
                            title={t('quiz_age_group_30_39')}
                            img={gender === 'homem' ? Home2 : Mulher2}
                            onClick={() => handleNextStep(() => setAge("30-39"))}
                        />
                        <Cards
                            title={t('quiz_age_group_40_49')}
                            img={gender === 'homem' ? Home3 : Mulher3}
                            onClick={() => handleNextStep(() => setAge("40-49"))}
                        />
                        <Cards
                            title={t('quiz_age_group_50_or_more')}
                            img={gender === 'homem' ? Home4 : Mulher4}
                            onClick={() => handleNextStep(() => setAge("50 ou mais"))}
                        />
                    </S.Content>
                </>
            )}

            {currentStep === 2 && (
                <>
                    <S.Title>
                        {t('quiz_step_goal_title')}
                    </S.Title>

                    <S.Content>
                        <Cards
                            title={t('quiz_step_goal_weight_loss_title')}
                            img={Weight}
                            onClick={() => handleNextStep(() => setGoal(t('quiz_step_goal_weight_loss_title')))}
                        />
                        <Cards
                            title={t('quiz_step_goal_muscle_gain_title')}
                            img={Close}
                            onClick={() => handleNextStep(() => setGoal(t('quiz_step_goal_muscle_gain_title')))}
                        />
                    </S.Content>
                </>
            )}

            {currentStep === 3 && (
                <>
                    <S.Title>
                        {t('quiz_step_body_type_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_body_type_slim')}
                            img=''
                            isSelected={selectedBodyType === t('quiz_step_body_type_slim')}
                            onClick={() => setSelectedBodyType(t('quiz_step_body_type_slim'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_body_type_medium')}
                            img=''
                            isSelected={selectedBodyType === t('quiz_step_body_type_medium')}
                            onClick={() => setSelectedBodyType(t('quiz_step_body_type_medium'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_body_type_overweight')}
                            img=''
                            isSelected={selectedBodyType === t('quiz_step_body_type_overweight')}
                            onClick={() => setSelectedBodyType(t('quiz_step_body_type_overweight'))}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 4 && (
                <>
                    <S.Title>
                        {t('quiz_step_body_goal_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_body_goal_defined')}
                            img=''
                            isSelected={bodyGoal === t('quiz_step_body_goal_defined')}
                            onClick={() => setBodyGoal(t('quiz_step_body_goal_defined'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_body_goal_muscular')}
                            img=''
                            isSelected={bodyGoal === t('quiz_step_body_goal_muscular')}
                            onClick={() => setBodyGoal(t('quiz_step_body_goal_muscular'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_body_goal_very_muscular')}
                            img=''
                            isSelected={bodyGoal === t('quiz_step_body_goal_very_muscular')}
                            onClick={() => setBodyGoal(t('quiz_step_body_goal_very_muscular'))}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 5 && (
                <>
                    <S.Title>
                        {t('quiz_step_motivation_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_motivation_health')}
                            img=''
                            isSelected={motivation === t('quiz_step_motivation_health')}
                            onClick={() => setMotivation(t('quiz_step_motivation_health'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_motivation_immunity')}
                            img=''
                            isSelected={motivation === t('quiz_step_motivation_immunity')}
                            onClick={() => setMotivation(t('quiz_step_motivation_immunity'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_motivation_appearance')}
                            img=''
                            isSelected={motivation === t('quiz_step_motivation_appearance')}
                            onClick={() => setMotivation(t('quiz_step_motivation_appearance'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_motivation_strength')}
                            img=''
                            isSelected={motivation === t('quiz_step_motivation_strength')}
                            onClick={() => setMotivation(t('quiz_step_motivation_strength'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_motivation_libido')}
                            img=''
                            isSelected={motivation === t('quiz_step_motivation_libido')}
                            onClick={() => setMotivation(t('quiz_step_motivation_libido'))}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 6 && (
                <>
                    <S.Title>
                        {t('quiz_step_target_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_target_arm')}
                            img=''
                            isSelected={target === t('quiz_step_target_arm')}
                            onClick={() => setTarget(t('quiz_step_target_arm'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_target_chest')}
                            img=''
                            isSelected={target === t('quiz_step_target_chest')}
                            onClick={() => setTarget(t('quiz_step_target_chest'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_target_abs')}
                            img=''
                            isSelected={target === t('quiz_step_target_abs')}
                            onClick={() => setTarget(t('quiz_step_target_abs'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_target_legs')}
                            img=''
                            isSelected={target === t('quiz_step_target_legs')}
                            onClick={() => setTarget(t('quiz_step_target_legs'))}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 7 && (
                <>
                    <S.Title>
                        {t('quiz_step_last_weight_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_last_weight_0_6_months')}
                            img=''
                            isSelected={lastWeight === t('quiz_step_last_weight_0_6_months')}
                            onClick={() => setLastWeight(t('quiz_step_last_weight_0_6_months'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_last_weight_7_12_months')}
                            img=''
                            isSelected={lastWeight === t('quiz_step_last_weight_7_12_months')}
                            onClick={() => setLastWeight(t('quiz_step_last_weight_7_12_months'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_last_weight_1_3_years')}
                            img=''
                            isSelected={lastWeight === t('quiz_step_last_weight_1_3_years')}
                            onClick={() => setLastWeight(t('quiz_step_last_weight_1_3_years'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_last_weight_more_than_3_years')}
                            img=''
                            isSelected={lastWeight === t('quiz_step_last_weight_more_than_3_years')}
                            onClick={() => setLastWeight(t('quiz_step_last_weight_more_than_3_years'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_last_weight_never')}
                            img=''
                            isSelected={lastWeight === t('quiz_step_last_weight_never')}
                            onClick={() => setLastWeight(t('quiz_step_last_weight_never'))}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 8 && (
                <>
                    <S.Title>
                        {t('quiz_step_conditioning_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_conditioning_beginner')}
                            description={t('quiz_step_conditioning_beginner_desc')}
                            img=''
                            isSelected={conditioning === t('quiz_step_conditioning_beginner')}
                            onClick={() => setConditioning(t('quiz_step_conditioning_beginner'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_conditioning_intermediate')}
                            description={t('quiz_step_conditioning_intermediate_desc')}
                            img=''
                            isSelected={conditioning === t('quiz_step_conditioning_intermediate')}
                            onClick={() => setConditioning(t('quiz_step_conditioning_intermediate'))}
                        />
                        <CardsSelect
                            title={t('quiz_step_conditioning_advanced')}
                            description={t('quiz_step_conditioning_advanced_desc')}
                            img=''
                            isSelected={conditioning === t('quiz_step_conditioning_advanced')}
                            onClick={() => setConditioning(t('quiz_step_conditioning_advanced'))}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 9 && (
                <>
                    <S.Title>
                        {t('quiz_step_interests_title')}
                    </S.Title>

                    <S.ContentWrap>
                        {data.map((item) => (
                            <CardsSelects
                                key={item}
                                title={item}
                                isSelected={selectedGoals.includes(item)}
                                onClick={() => toggleGoalSelection(item)}
                            />
                        ))}
                    </S.ContentWrap>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 10 && (
                <>
                    <S.Title>
                        {t('quiz_step_pushups_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_pushups_option_1')}
                            img=''
                            isSelected={pushUps === "Menos de 12"}
                            onClick={() => setPushUps("Menos de 12")}
                        />
                        <CardsSelect
                            title={t('quiz_step_pushups_option_2')}
                            img=''
                            isSelected={pushUps === "De 13 a 20"}
                            onClick={() => setPushUps("De 13 a 20")}
                        />
                        <CardsSelect
                            title={t('quiz_step_pushups_option_3')}
                            img=''
                            isSelected={pushUps === "Mais de 20"}
                            onClick={() => setPushUps("Mais de 20")}
                        />
                        <CardsSelect
                            title={t('quiz_step_pushups_option_4')}
                            img=''
                            isSelected={pushUps === "Não sei"}
                            onClick={() => setPushUps("Não sei")}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 11 && (
                <>
                    <S.Title>
                        {t('quiz_step_lifestyle_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_lifestyle_option_1')}
                            img=''
                            isSelected={lifestyle === "Sim"}
                            onClick={() => setLifestyle("Sim")}
                        />
                        <CardsSelect
                            title={t('quiz_step_lifestyle_option_2')}
                            img=''
                            isSelected={lifestyle === "Não"}
                            onClick={() => setLifestyle("Não")}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 12 && (
                <>
                    <S.Title>
                        {t('quiz_step_walk_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_walk_option_1')}
                            img=''
                            isSelected={youWalk === "Menos de 1 hora"}
                            onClick={() => setYouWalk("Menos de 1 hora")}
                        />
                        <CardsSelect
                            title={t('quiz_step_walk_option_2')}
                            img=''
                            isSelected={youWalk === "De 1 a 2 horas"}
                            onClick={() => setYouWalk("De 1 a 2 horas")}
                        />
                        <CardsSelect
                            title={t('quiz_step_walk_option_3')}
                            img=''
                            isSelected={youWalk === "Mais de 2 horas"}
                            onClick={() => setYouWalk("Mais de 2 horas")}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 13 && (
                <>
                    <S.Title>
                        {t('quiz_step_meals_title')}
                    </S.Title>

                    <S.Description>
                        {t('quiz_step_meals_description')}
                    </S.Description>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_meals_option_1')}
                            img=''
                            isSelected={meals === "Eu fico com sono quando estou com fome"}
                            onClick={() => setMeals("Eu fico com sono quando estou com fome")}
                        />
                        <CardsSelect
                            title={t('quiz_step_meals_option_2')}
                            img=''
                            isSelected={meals === "Eu me sinto cansado depos de comer"}
                            onClick={() => setMeals("Eu me sinto cansado depos de comer")}
                        />
                        <CardsSelect
                            title={t('quiz_step_meals_option_3')}
                            img=''
                            isSelected={meals === "Eu estou sempre me sentindo energizado"}
                            onClick={() => setMeals("Eu estou sempre me sentindo energizado")}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 14 && (
                <>
                    <S.Title>
                        {t('quiz_step_sleeps_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_sleeps_option_1')}
                            img=''
                            isSelected={sleeps === "Menos de 5 horas"}
                            onClick={() => setSleeps("Menos de 5 horas")}
                        />
                        <CardsSelect
                            title={t('quiz_step_sleeps_option_2')}
                            img=''
                            isSelected={sleeps === "Entre 5 a 6 horas"}
                            onClick={() => setSleeps("Entre 5 a 6 horas")}
                        />
                        <CardsSelect
                            title={t('quiz_step_sleeps_option_3')}
                            img=''
                            isSelected={sleeps === "Entre 7 a 8 horas"}
                            onClick={() => setSleeps("Entre 7 a 8 horas")}
                        />
                        <CardsSelect
                            title={t('quiz_step_sleeps_option_4')}
                            img=''
                            isSelected={sleeps === "Mais de 8 horas"}
                            onClick={() => setSleeps("Mais de 8 horas")}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 15 && (
                <>
                    <S.Title>
                        {t('quiz_step_water_title')}
                    </S.Title>

                    <S.Description>
                        {t('quiz_step_water_description')}
                    </S.Description>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_water_option_1')}
                            img=''
                            isSelected={water === "Eu bebo apenas chá e café"}
                            onClick={() => setWater("Eu bebo apenas chá e café")}
                        />
                        <CardsSelect
                            title={t('quiz_step_water_option_2')}
                            img=''
                            isSelected={water === "Menos de 2 copos de água"}
                            onClick={() => setWater("Menos de 2 copos de água")}
                        />
                        <CardsSelect
                            title={t('quiz_step_water_option_3')}
                            img=''
                            isSelected={water === "2-6 copos de água"}
                            onClick={() => setWater("2-6 copos de água")}
                        />
                        <CardsSelect
                            title={t('quiz_step_water_option_4')}
                            img=''
                            isSelected={water === "7-10 copos de água"}
                            onClick={() => setWater("7-10 copos de água")}
                        />
                        <CardsSelect
                            title={t('quiz_step_water_option_5')}
                            img=''
                            isSelected={water === "Mais de 10 copos de água"}
                            onClick={() => setWater("Mais de 10 copos de água")}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 16 && (
                <>
                    <S.Title>
                        {t('quiz_step_training_title')}
                    </S.Title>

                    <S.ContentLeft>
                        <CardsSelect
                            title={t('quiz_step_training_option_1_title')}
                            description={t('quiz_step_training_option_1_description')}
                            img=''
                            isSelected={training === "Casa"}
                            onClick={() => setTraining("Casa")}
                        />
                        <CardsSelect
                            title={t('quiz_step_training_option_2_title')}
                            description={t('quiz_step_training_option_2_description')}
                            img=''
                            isSelected={training === "Academia"}
                            onClick={() => setTraining("Academia")}
                        />
                        <CardsSelect
                            title={t('quiz_step_training_option_3_title')}
                            description={t('quiz_step_training_option_3_description')}
                            img=''
                            isSelected={training === "Híbrido"}
                            onClick={() => setTraining("Híbrido")}
                        />
                    </S.ContentLeft>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 17 && (
                <>
                    <S.Title>
                        {t('quiz_step_special_occasion_title')}
                    </S.Title>

                    <S.Description>
                        {t('quiz_step_special_occasion_description')}
                    </S.Description>

                    <S.ContentWrap>
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_1_title')}
                            img=''
                            isSelected={occasion === "Férias 🏖️"}
                            onClick={() => setOccasion("Férias 🏖️")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_2_title')}
                            img=''
                            isSelected={occasion === "Competição 🏆"}
                            onClick={() => setOccasion("Competição 🏆")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_3_title')}
                            img=''
                            isSelected={occasion === "Data importante 📅"}
                            onClick={() => setOccasion("Data importante 📅")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_4_title')}
                            img=''
                            isSelected={occasion === "Esportes extremos 🧗"}
                            onClick={() => setOccasion("Esportes extremos 🧗")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_5_title')}
                            img=''
                            isSelected={occasion === "Aniversário 🎂"}
                            onClick={() => setOccasion("Aniversário 🎂")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_6_title')}
                            img=''
                            isSelected={occasion === "Ida à praia 🏄"}
                            onClick={() => setOccasion("Ida à praia 🏄")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_7_title')}
                            img=''
                            isSelected={occasion === "Encontro ❤️"}
                            onClick={() => setOccasion("Encontro ❤️")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_8_title')}
                            img=''
                            isSelected={occasion === "Reunião familiar 👪"}
                            onClick={() => setOccasion("Reunião familiar 👪")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_9_title')}
                            img=''
                            isSelected={occasion === "Casamento 💒"}
                            onClick={() => setOccasion("Casamento 💒")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_10_title')}
                            img=''
                            isSelected={occasion === "Outro 🔍"}
                            onClick={() => setOccasion("Outro 🔍")}
                        />
                        <CardsSelect
                            title={t('quiz_step_special_occasion_option_11_title')}
                            img=''
                            isSelected={occasion === "Não 🚫"}
                            onClick={() => setOccasion("Não 🚫")}
                        />
                    </S.ContentWrap>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 18 && (
                <>
                    <S.Title>
                        {t('quiz_step_height_title')}
                    </S.Title>

                    <S.ContentWrap>
                        <Input
                            placeholder={t('quiz_step_height_placeholder')}
                            value={height}
                            onChange={(text) => setHeight(text.target.value)}
                        />
                    </S.ContentWrap>
                    <div style={{ marginTop: 30, justifyContent: 'center', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <S.Description>
                            {t('quiz_step_bmi_calculation_description')}
                        </S.Description>
                        <CardsSelect
                            img="..."  // Adicione a imagem conforme necessário
                            description={t('quiz_step_bmi_description')}
                        />
                    </div>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 19 && (
                <>
                    <S.Title>
                        {t('quiz_step_weight_title')}
                    </S.Title>

                    <S.ContentWrap>
                        <Input
                            placeholder={t('quiz_step_height_placeholder')}
                            value={weight}
                            onChange={(text) => setWeight(text.target.value)}
                        />
                    </S.ContentWrap>
                    <div style={{ marginTop: 30, justifyContent: 'center', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <S.Description>
                            {t('quiz_step_bmi_calculation_description')}
                        </S.Description>
                        <CardsSelect
                            img="..."  // Adicione a imagem conforme necessário
                            description={t('quiz_step_bmi_description')}
                        />
                    </div>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 20 && (
                <>
                    <S.Title>
                        {t('quiz_step_weight_goal_title')}
                    </S.Title>

                    <S.ContentWrap>
                        <Input
                            placeholder={t('quiz_step_weight_goal_placeholder')}
                            value={weightGoal}
                            onChange={(text) => setWeightGoal(text.target.value)}
                        />
                    </S.ContentWrap>

                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 21 && (
                <>
                    {imc && (
                        <>
                            <S.Title>
                                {t('quiz_imc_title')}
                            </S.Title>
                            <S.Content>
                                <S.SliderImage src={getIMCImage(parseFloat(imc))} alt="" />
                                <div style={{ width: '10%' }}>
                                    <Lottie
                                        options={{
                                            animationData: arrowLeft,
                                            loop: true,
                                            autoplay: true,
                                        }}
                                        style={{ width: '100%', height: '100%' }}
                                    />
                                </div>
                                <S.SliderImage src={gender === 'homem' ? Man2 : Woman2} alt="" />
                            </S.Content>

                            <S.Title>
                                📊 {t('quiz_imc_message', { imc })}
                            </S.Title>
                            <S.CardImc status={status}>
                                <S.Description>
                                    {getIMCMessage(parseFloat(imc))}
                                </S.Description>
                            </S.CardImc>
                        </>
                    )}
                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 22 && (
                <>
                    <Chart type="line" data={chartData} options={chartOptions} />
                    <S.Title>
                        {t('quiz_motivational_message')}
                    </S.Title>

                    <S.Description>
                        {getMotivationMessage()}
                    </S.Description>
                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </>
            )}

            {currentStep === 23 && (
                <S.ContentLeft>
                    <S.Title>
                        {t('quiz_what_is_your_name')}
                    </S.Title>

                    <S.Description>
                        {t('quiz_lets_save_your_data')}
                    </S.Description>

                    <Input
                        placeholder={t('quiz_type_your_name')}
                        width
                        value={name}
                        onChange={(text) => setName(text.target.value)}
                    />
                    <ButtonDefault
                        title={t('quiz_step_continue_button')}
                        onClick={handleContinue}
                    />
                </S.ContentLeft>
            )}

            {currentStep > totalSteps && (
                <S.ContentLeft>
                    <S.Title>
                        {t('quiz_title_email')}
                    </S.Title>

                    <S.Description>
                        {t('quiz_description_email')}
                    </S.Description>

                    <Input
                        placeholder={t('quiz_input_placeholder')}
                        width
                        value={email}
                        onChange={(text) => setEmail(text.target.value)}
                    />

                    <ButtonDefault
                        title={t('quiz_button_text')}
                        onClick={handleFunctions}
                    />
                </S.ContentLeft>
            )}

            <ToastContainer />
        </S.Container>
    );
}
